import React, {MouseEvent, useCallback, useState} from 'react';
import {toast} from 'react-toastify';
import {t} from '@lingui/core/macro';

import {ITariff, tariffAPI} from 'entities/tariff';
import MoreActionsItem from 'shared/ui/MoreActions/MoreActionsItem';
import EntityActionsMenu from 'shared/ui/MoreActions/EntityActionsMenu';
import ConfirmModal from 'shared/ui/Modal/ConfirmModal/ConfirmModal';
import ByDefault from 'shared/ui/icons/TablesMenu/ByDefault';

interface ITariffMenuProps {
    item: ITariff,
    onEditClick: (_event: MouseEvent) => void,
}

const TariffMenu: React.FC<ITariffMenuProps> = ({item, onEditClick}) => {
    const [isDeleteOpen, setIsDeleteOpen] = useState(false);
    const [deleteTariff, {isLoading}] = tariffAPI.useDeleteTariffMutation();
    const [defaultTariff] = tariffAPI.useDefaultTariffMutation();

    const closeDelete = useCallback(() => setIsDeleteOpen(false), []);

    const onConfirmDelete = useCallback(async() => {
        const result = await deleteTariff(item.id);
        if ('error' in result) return;
        toast.info(t`Тариф удален`);
        closeDelete();
    }, [item.id, deleteTariff, closeDelete]);

    const onClickDefault = useCallback(async(event: MouseEvent) => {
        event.stopPropagation();
        const response = await defaultTariff(item.id).unwrap();
        toast.info(response.message);
    }, [item.id, defaultTariff]);

    const onClickDelete = useCallback((event: MouseEvent) => {
        event.stopPropagation();
        setIsDeleteOpen(true);
    }, []);

    const extraActions = item.is_default ? [] : [
        <MoreActionsItem
            key="default"
            label={t`По умолчанию`}
            icon=<ByDefault/>
            onClick={onClickDefault}
        />,
    ];

    return (
        <>
            <EntityActionsMenu
                onEdit={onEditClick}
                onDelete={onClickDelete}
                extraActions={extraActions}
                placement="auto"
            />
            <ConfirmModal
                variant="delete"
                open={isDeleteOpen}
                handleClose={closeDelete}
                header={t`Удаление тарифа`}
                title={t`Вы уверены, что хотите удалить тариф`}
                name={item.name}
                confirmText={t`Удалить`}
                onConfirm={onConfirmDelete}
                isLoading={isLoading}
            />
        </>
    );
};

export default React.memo(TariffMenu);
